import {
  StyledLabel,
  StyledTable,
  StyledTableCell,
  StyledTableCellHead,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
  StyledTableRowHead,
} from './styles';
import { ITableProps } from './types';

function getCellBorderRadius(
  rowIdx: number,
  cellIdx: number,
  rowsCount: number,
  colsCount: number
) {
  // Одна строка
  if (rowsCount === 1) {
    if (cellIdx === 0 && colsCount === 1) return '20px';
    if (cellIdx === 0) return '20px 0 0 20px';
    if (cellIdx === colsCount - 1) return '0 20px 20px 0';
    return '0';
  }

  // Первая строка
  if (rowIdx === 0) {
    if (cellIdx === 0) return '20px 0 0 0';
    if (cellIdx === colsCount - 1) return '0 20px 0 0';
  }

  // Последняя строка
  if (rowIdx === rowsCount - 1) {
    if (cellIdx === 0) return '0 0 0 20px';
    if (cellIdx === colsCount - 1) return '0 0 20px 0';
  }

  return '';
}

function getCellBorders(
  rowIdx: number,
  cellIdx: number,
  rowsCount: number,
  colsCount: number
): {
  $borderTopWidth?: string;
  $borderBottomWidth?: string;
  $borderLeftWidth?: string;
  $borderRightWidth?: string;
} {
  return {
    $borderTopWidth: rowIdx === 0 ? '1px' : '2px',
    $borderBottomWidth: '1px',
    $borderLeftWidth: cellIdx === 0 ? '1px' : undefined,
    $borderRightWidth: cellIdx === colsCount - 1 ? '1px' : undefined,
  };
}

export const Table = ({ data, columns }: ITableProps) => {
  const rowsCount = data.length;
  return (
    <StyledTableContainer>
      <StyledTable>
        {columns ? (
          <StyledTableHead>
            <StyledTableRowHead>
              {columns.map(({ key, label, ...otherColumnProps }) => (
                <StyledTableCellHead key={key} {...otherColumnProps}>
                  <StyledLabel variant="caption">{label}</StyledLabel>
                </StyledTableCellHead>
              ))}
            </StyledTableRowHead>
          </StyledTableHead>
        ) : null}
        <tbody>
          {data.map((row, rowIdx) => (
            <StyledTableRow key={row.key}>
              {row.columns.map(
                ({ key, value, ...otherColumnProps }, cellIdx) => {
                  const colsCount = row.columns.length;
                  const $borderRadius = getCellBorderRadius(
                    rowIdx,
                    cellIdx,
                    rowsCount,
                    colsCount
                  );
                  const borders = getCellBorders(
                    rowIdx,
                    cellIdx,
                    rowsCount,
                    colsCount
                  );
                  return (
                    <StyledTableCell
                      key={key}
                      $borderRadius={$borderRadius}
                      {...otherColumnProps}
                      {...borders}
                    >
                      {value}
                    </StyledTableCell>
                  );
                }
              )}
            </StyledTableRow>
          ))}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
};
